export default [
  {
    // roleManagement
    path: "/organizationalManagement",
    name: "集团管理",
    component: (resolve) => require(["@/views/home"], resolve),
    children: [
      {
        path: "roleManagement",
        name: "角色管理 ",
        meta: {
          title: "角色管理",
        },
        component: (resolve) =>
          require([
            "@/views/organizationalManagement/roleManagement/index.vue",
          ], resolve),
      },
      {
        path: "auditProcess",
        name: "审核流程 ",
        meta: {
          title: "审核流程",
        },
        component: (resolve) =>
          require([
            "@/views/organizationalManagement/auditProcess/index.vue",
          ], resolve),
      },
      {
        path: "publishProcess",
        name: "出版流程",
        meta: {
          title: "出版流程",
        },
        component: (resolve) =>
          require([
            "@/views/organizationalManagement/publishProcess/index.vue",
          ], resolve),
      },
      {
        path: "publishProcess/addPublish",
        name: "新建流程",
        meta: {
          title: "新建流程",
        },
        component: (resolve) =>
          require([
            "@/views/organizationalManagement/publishProcess/addPublish.vue",
          ], resolve),
      },
      {
        path: "groupsManagement",
        name: "群组管理",
        meta: {
          title: "群组管理",
        },
        component: (resolve) =>
          require([
            "@/views/organizationalManagement/groupsManagement/index.vue",
          ], resolve),
      },
      {
        path: "groupsManagement/groupSetting",
        name: "组员设置",
        meta: {
          title: "组员设置",
        },
        component: (resolve) =>
          require([
            "@/views/organizationalManagement/groupsManagement/groupSetting.vue",
          ], resolve),
      },
      {
        path: "auditProcess/editor",
        name: "新建流程 ",
        meta: {
          title: "新建流程",
        },
        component: (resolve) =>
          require([
            "@/views/organizationalManagement/auditProcess/editor.vue",
          ], resolve),
      },
      {
        path: "userManagement",
        name: "用户管理",
        meta: {
          title: "用户管理",
        },
        component: (resolve) =>
          require(["@/views/organizationalManagement/userManagement"], resolve),
      },
      {
        path: "periodicalSet",
        name: "期刊设置",
        meta: {
          title: "期刊设置",
        },
        component: (resolve) =>
          require(["@/views/organizationalManagement/periodicalSet"], resolve),
      },
      // 2022/12 v2.6.1 新增 外审设置
      {
        path: "externalAuditSetting",
        name: "外审设置",
        meta: {
          title: "外审设置",
        },
        component: (resolve) =>
          require([
            "@/views/organizationalManagement/externalAuditSetting",
          ], resolve),
      },
      // 2023/11 新增清样设置
      {
        path: "periodicalTypesetting",
        name: "校样设置",
        meta: {
          title: "校样设置",
        },
        component: (resolve) =>
          require([
            "@/views/organizationalManagement/periodicalTypesetting",
          ], resolve),
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/organizationalManagement_routers.js